import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback, useDebounce } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import $ from "jquery";
import moment from "moment";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Modal,
  Link,
  TableSortLabel,
  Avatar,
  IconButton,
  Chip,
  Fade,
  Backdrop,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { fetchTournamentData } from "../../action/tournamentsAction";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import TournamentVideoDeleteModal from "../../component/Modals/DeleteModal";
import ViewTournament from "../../component/Modals/ViewTournament";
import LisitingSkeleton from "../common/LisitingSkeleton";

const goalsColumn = [
  { id: "tournament_select", label: "", minWidth: 105 },
  { id: "title", label: "TITLE", minWidth: 105 },
  { id: "tournament_visibility", label: "VISIBILITY", minWidth: 500 },
  { id: "tournament_category", label: "CATEGORY", minWidth: 210 },
  { id: "club", label: "CLUB NAME", minWidth: 180 },
  { id: "region", label: "REGION", minWidth: 290 },
  { id: "tournament_videos", label: "VIDEOS", minWidth: 290 },
  { id: "members", label: "MEMBERS", minWidth: 120 },
  { id: "tournament_createedAt", label: "CREATED AT", minWidth: 290 },
  { id: "tournament_actions", label: "ACTIONS", minWidth: 290 },
];

const columnsToSort = ["title", "club", "region"];

export default function Goals() {
  const { data: goalData, loading = false } = useSelector(
    (state) => state.tournaments
  );
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const deleteChildSelected = useRef(null);
  const [userView, setUserView] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [selectVideos, setSelectVideos] = useState(null);
  const [childMark, setChildMark] = useState(false);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("ASC");
  const [openMembers, setOpenMembers] = useState(false);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [uploadingUser, setUploadingUser] = useState(null);

  // Local state to track real-time avatar updates without closing the modal
  const [localAvatars, setLocalAvatars] = useState({});

  const debouncedSearch = useDebounce(searchInput, 800);

  useEffect(() => {
    dispatch(fetchTournamentData(token, 1));
  }, [dispatch, token]);

  // Reset local avatars when modal opens for a new tournament
  useEffect(() => {
    if (openMembers) {
      setLocalAvatars({});
    }
  }, [openMembers]);

  useEffect(() => {
    if (goalData?.success) {
      if (goalData.data?.rows?.length > 0) {
        setGoals(goalData?.data.rows);
        setCurrentPage(goalData?.data?.currentPage);
        setTotalPages(goalData?.data?.totalPages);
      } else {
        setGoals("NO Leads!");
      }
    } else if (!goalData?.success) {
      setGoals(goalData?.message);
    }
  }, [goalData]);

  const handleChangePage = (event, newPage) => {
    dispatch(fetchTournamentData(token, newPage, sortColumn, sortOrder));
  };

  useEffect(() => {
    dispatch(
      fetchTournamentData(token, 1, sortColumn, sortOrder, debouncedSearch)
    );
  }, [sortColumn, sortOrder, debouncedSearch]);

  const handleSort = (column) => {
    const isAsc = sortColumn == column && sortOrder == "ASC";
    setSortOrder(isAsc ? "DESC" : "ASC");
    setSortColumn(column);
  };

  function handleSearchClick() {
    if (debouncedSearch.trim() !== "") {
      dispatch(
        fetchTournamentData(
          token,
          currentPage,
          sortColumn,
          sortOrder,
          debouncedSearch
        )
      );
    }
  }

  function handleDeleteClose() {
    setOpenDelete(false);
  }

  async function handleDelete() {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/deleteTournament/${deleteSelected.current.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        dispatch(
          fetchTournamentData(token, currentPage, sortColumn, sortOrder)
        );
        toast.success("Tournament deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  async function handleTournamentVideoDelete(data) {
    try {
      if (data.current.id) {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/deleteTournamentVideo/${data.current.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) {
          dispatch(
            fetchTournamentData(token, currentPage, sortColumn, sortOrder)
          );
          toast.success("Tournament deleted successfully");
          setSelectVideos((prev) => {
            prev.delete(data.current.id);
            return prev;
          });
        }
      } else {
        toast.error("no id found !!");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  async function handleTVideoElite() {
    if (deleteChildSelected.current.id) {
      try {
        const mark = deleteChildSelected.current.elite ? false : true;
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/markElite`,
          {
            id: deleteChildSelected.current.id,
            elite: mark,
            tournamentVideo: true,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data.success) {
          dispatch(
            fetchTournamentData(token, currentPage, sortColumn, sortOrder)
          );
          setSelectVideos((prev) => {
            prev.set(deleteChildSelected.current.id, {
              ...deleteChildSelected.current,
              elite: mark,
            });
            return prev;
          });
          toast.success(response.data?.message);
        }
      } catch (error) {
        toast.error("Please try again..");
      } finally {
        setChildMark(false);
      }
    } else {
      toast.error("no id found !!");
    }
  }

  async function handleMultipleDelete() {
    try {
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0]
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleTournament`,
        { ids },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        dispatch(
          fetchTournamentData(token, currentPage, sortColumn, sortOrder)
        );
        toast.success("Selected videos deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  async function handleMemberProfileUpload(event, user) {
    try {
      const file = event.target.files[0];
      if (!file) return;

      setUploadingUser(user.id);

      // Preview immediately — real-time update in modal
      const localUrl = URL.createObjectURL(file);
      setLocalAvatars((prev) => ({ ...prev, [user.id]: localUrl }));

      const formData = new FormData();
      formData.append("profileImage", file);
      formData.append("user_id", user.id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/editUserDetails`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Profile image updated successfully");
        // Replace blob preview with server URL if returned
        if (response.data.profileUrl) {
          setLocalAvatars((prev) => ({
            ...prev,
            [user.id]: response.data.profileUrl,
          }));
        }
        dispatch(
          fetchTournamentData(token, currentPage, sortColumn, sortOrder)
        );
      }
    } catch (error) {
      // Revert preview on failure
      setLocalAvatars((prev) => {
        const updated = { ...prev };
        delete updated[user.id];
        return updated;
      });
      toast.error(error?.response?.data?.message || "Failed to upload image");
    } finally {
      setUploadingUser(null);
      event.target.value = "";
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Box className="page_title tournament_title">
        <Typography variant="h1" component="h1">
          Tournaments
        </Typography>
      </Box>
      <Box className="page_inner">
        <Box className="search_box_wrapper">
          <Box className="search_box">
            <Box className="input-wrapper">
              <SearchIcon className="searchIcon" onClick={handleSearchClick} />
              <input
                placeholder="search by title, club name, category name"
                type="text"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    dispatch(
                      fetchTournamentData(
                        token,
                        1,
                        sortColumn,
                        sortOrder,
                        debouncedSearch
                      )
                    );
                  }
                }}
              />
              <Button
                className="delete-search-btn"
                onClick={() => {
                  if (
                    multipleSelect.current &&
                    multipleSelect.current.size > 0
                  ) {
                    setOpenMulitDelete(true);
                  } else {
                    toast.error("Please select at least one video");
                  }
                }}
              >
                <DeleteOutlineIcon className="delete-icon" />
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "900px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id !== "tournament_select" ? (
                      <TableCell key={column.id}>
                        {columnsToSort.includes(column.id) ? (
                          <TableSortLabel
                            active={sortColumn === column.id}
                            onClick={() => handleSort(column.id)}
                            direction={sortOrder.toLowerCase()}
                          >
                            {column.label}
                          </TableSortLabel>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  Array.from({ length: 10 }).map((e, i) => (
                    <LisitingSkeleton key={i} />
                  ))
                ) : Array.isArray(goals) && goals.length > 0 ? (
                  goals.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="t_title"
                          >
                            {value?.title}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="td-text"
                          >
                            {value?.visibility ? "Public" : "Private"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper-goalCat">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.categoryName}
                          </Typography>
                          {value?.subCategoryName && (
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text sub-cat"
                            >
                              {value?.subCategoryName}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.club}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.region}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            <a
                              href=""
                              className="tournament_video"
                              onClick={(e) => {
                                e.preventDefault();
                                if (value?.tournamentGoalVideos?.length > 0) {
                                  setSelectVideos(
                                    new Map(
                                      value.tournamentGoalVideos.map((v) => [
                                        v.id,
                                        v,
                                      ])
                                    )
                                  );
                                  setShowVideo(true);
                                }
                              }}
                            >
                              {(value?.tournamentGoalVideos?.length || 0) +
                                " Videos"}
                            </a>
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              setSelectedTournament(value);
                              setOpenMembers(true);
                            }}
                          >
                            {value.memberCount} Members
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {moment(value.createdAt).format(
                              "MMMM Do, YYYY HH:mm"
                            )}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              sx={{ minWidth: "40px", p: 0 }}
                              onClick={() => {
                                deleteSelected.current = value;
                                setOpenDelete(true);
                              }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                deleteSelected.current = value;
                                setUserView(true);
                              }}
                            >
                              <VisibilityIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow component="tr">
                    <TableCell colSpan={8} style={{ textAlign: "center" }}>
                      No Tournaments!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* Delete tournament */}
      <Modal open={openDelete} onClose={handleDeleteClose}>
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure. You want to delete this Tournament.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              Cancel
            </Button>
            <Button variant="outlined" onClick={handleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <ViewTournament
        setUserView={setUserView}
        userView={userView}
        deleteSelected={deleteSelected}
      />

      {/* Show video tournament */}
      <Modal open={showVideo} onClose={() => setShowVideo(false)}>
        <Box className="deleteModal" sx={{ padding: "0", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ width: "100%" }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">THUMB</TableCell>
                  <TableCell align="left">ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectVideos && selectVideos.size > 0
                  ? Array.from(selectVideos.entries())
                      .map((ele) => ele[1])
                      .map((video, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="right">
                            <Box className="tourna_video_model">
                              <Box className="p_image">
                                <ImageWithFallback
                                  src={video.thumbnail}
                                  alt={""}
                                  fallbackSrc={BlankImg}
                                />
                                <Box className="playIcon-wrapper">
                                  <Box
                                    component={Link}
                                    href={video?.video}
                                    target="_blank"
                                  >
                                    <PlayArrowIcon className="playIcon" />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            <Box className="table-actions">
                              <Box className="action-wrapper">
                                <TournamentVideoDeleteModal
                                  deleteSelected={deleteChildSelected}
                                  video={video}
                                  handleTournamentVideoDelete={
                                    handleTournamentVideoDelete
                                  }
                                />
                                <Button
                                  variant="outlined"
                                  className={
                                    video?.elite
                                      ? "action-button elite"
                                      : "action-button"
                                  }
                                  onClick={() => {
                                    deleteChildSelected.current = video;
                                    setChildMark(true);
                                  }}
                                >
                                  {video?.elite
                                    ? "Marked as Elite"
                                    : "Mark as Elite"}
                                </Button>
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                  : "no value in state"}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>

      {/* Mark elite */}
      <Modal open={childMark} onClose={() => setChildMark(false)}>
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {deleteChildSelected.current && deleteChildSelected.current?.elite
              ? "Are You sure. You want to remove this video from Elite."
              : "Are You sure. You want to Mark this video as Elite."}
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setChildMark(false)}>
              Cancel
            </Button>
            <Button variant="outlined" onClick={handleTVideoElite}>
              {deleteChildSelected.current && deleteChildSelected.current?.elite
                ? "REMOVE FROM ELITE"
                : "MARK AS ELITE"}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* =============================================
          TOURNAMENT MEMBERS MODAL — Redesigned
      ============================================= */}
      <Modal
        open={openMembers}
        onClose={() => setOpenMembers(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 250 } }}
      >
        <Fade in={openMembers}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "92%", sm: "72%", md: "58%" },
              maxWidth: "700px",
              bgcolor: "#fff",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(15,23,42,0.18)",
              outline: "none",
              display: "flex",
              flexDirection: "column",
              maxHeight: "72vh",
            }}
          >
            {/* HEADER */}
            <Box
              sx={{
                px: 2.5,
                py: 1.5,
                background: "#ef4444",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "8px",
                    background: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PeopleAltRoundedIcon sx={{ color: "#fff", fontSize: 17 }} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#fff",
                      lineHeight: 1.2,
                    }}
                  >
                    Tournament Members
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "rgba(255,255,255,0.75)",
                      lineHeight: 1.2,
                    }}
                  >
                    {selectedTournament?.invitedUsers?.length || 0} member
                    {(selectedTournament?.invitedUsers?.length || 0) !== 1
                      ? "s"
                      : ""}
                  </Typography>
                </Box>
              </Box>

              <IconButton
                onClick={() => setOpenMembers(false)}
                size="small"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  "&:hover": {
                    color: "#fff",
                    background: "rgba(255,255,255,0.15)",
                  },
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* BODY — compact list */}
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                background: "#f8fafc",
                "&::-webkit-scrollbar": { width: "5px" },
                "&::-webkit-scrollbar-track": { background: "#f1f5f9" },
                "&::-webkit-scrollbar-thumb": {
                  background: "#cbd5e1",
                  borderRadius: "10px",
                },
              }}
            >
              {selectedTournament?.invitedUsers?.length > 0 ? (
                <Box
                  sx={{
                    p: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  {selectedTournament.invitedUsers.map((member, index) => {
                    const isAccepted = Number(member.accept) === 1;
                    const avatarSrc =
                      localAvatars[member.id] || member.profile_img;

                    return (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          background: "#fff",
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0",
                          px: 2,
                          py: 1.2,
                          transition: "box-shadow 0.15s",
                          "&:hover": {
                            boxShadow: "0 2px 10px rgba(15,23,42,0.07)",
                          },
                        }}
                      >
                        {/* Avatar + upload */}
                        <Box sx={{ position: "relative", flexShrink: 0 }}>
                          <Avatar
                            src={avatarSrc}
                            sx={{
                              width: 44,
                              height: 44,
                              border: "2px solid #f1f5f9",
                            }}
                          />

                          {uploadingUser === member.id ? (
                            <Box
                              sx={{
                                position: "absolute",
                                inset: 0,
                                borderRadius: "50%",
                                background: "rgba(0,0,0,0.45)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CircularProgress
                                size={16}
                                sx={{ color: "#fff" }}
                              />
                            </Box>
                          ) : (
                            <Tooltip title="Change photo" arrow placement="top">
                              <IconButton
                                size="small"
                                component="label"
                                sx={{
                                  position: "absolute",
                                  right: -4,
                                  bottom: -4,
                                  width: 20,
                                  height: 20,
                                  background: "#ef4444",
                                  color: "#fff",
                                  "&:hover": { background: "#dc2626" },
                                }}
                              >
                                <EditIcon sx={{ fontSize: 11 }} />
                                <input
                                  hidden
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleMemberProfileUpload(e, member)
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>

                        {/* Name + email */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "13px",
                              color: "#0f172a",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {member.firstName} {member.lastName}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#64748b",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {member.email}
                          </Typography>
                        </Box>

                        {/* Status badge */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            px: 1.2,
                            py: 0.4,
                            borderRadius: "20px",
                            flexShrink: 0,
                            background: isAccepted ? "#dcfce7" : "#f1f5f9",
                            color: isAccepted ? "#16a34a" : "#64748b",
                          }}
                        >
                          {isAccepted ? (
                            <CheckCircleRoundedIcon sx={{ fontSize: 13 }} />
                          ) : (
                            <HourglassTopRoundedIcon sx={{ fontSize: 13 }} />
                          )}
                          <Typography
                            sx={{ fontSize: "11px", fontWeight: 700 }}
                          >
                            {isAccepted ? "Accepted" : "Pending"}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <PeopleAltRoundedIcon
                    sx={{ fontSize: 44, color: "#cbd5e1", mb: 1 }}
                  />
                  <Typography sx={{ color: "#94a3b8", fontSize: "14px" }}>
                    No members found
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* Multiple delete */}
      <Modal open={openMulitDelete} onClose={() => setOpenMulitDelete(false)}>
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure. You want to delete the selected users.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
            >
              Cancel
            </Button>
            <Button variant="outlined" onClick={handleMultipleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
